module.exports = {
      id: "summary-usage",
      viewBox: "0 0 15 15",
      url: __webpack_public_path__ + "svg-sprite-8e03654a4a2895e52544254db36238f1.svg#summary",
      toString: function () {
        return this.url;
      }
    }